import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'coursesAreas': [],
  'coursesAreaSelected': null,
  'loading': false,
};

export const wtsCoursesAreas = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_COURSES_AREAS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_COURSES_AREAS]: (state, action) => ({
      ...state,
      'loading': false,
      'coursesAreas': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_COURSES_AREAS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'coursesAreas': [],
    }),
    [ActionTypes.CHANGE_WTS_COURSE_AREA_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'coursesAreaSelected': action.payload,
    }),
  })(state, action);
};
